import { render, staticRenderFns } from "./DialogSplitOrder.pug?vue&type=template&id=5244216e&scoped=true&lang=pug&"
import script from "./DialogSplitOrder.vue?vue&type=script&lang=js&"
export * from "./DialogSplitOrder.vue?vue&type=script&lang=js&"
import style0 from "./DialogSplitOrder.scss?vue&type=style&index=0&id=5244216e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5244216e",
  null
  
)

export default component.exports